import { createAnnouncement } from './createAnnouncement';
import { fetchAnnouncements } from './fetchAnnouncements';
import { updateAnnouncement } from './updateAnnouncement';

export const announcementService = {
  createAnnouncement,
  fetchAnnouncements,
  updateAnnouncement,
};
